<div class="app-workitem-lens-list">
  <div class="bc-sidenav-title-wrapper">
    <h2 class="bc-sidenav-title">
      <svg-icon icon="lens"></svg-icon>
      <span class="bc-sidenav-title-label">{{ ( isHybrid ? 'bcWorkItemLensList.dxTitle' : 'bcWorkItemLensList.title' ) | translate}}</span>
      <span> ({{ lensSessionsCount }})</span>
    </h2>
    <button class="btn btn-add"
            [attr.aria-label]="'bcWorkItemLensList.newLensTooltip' | translate"
            (click)="onNewLensClicked()"
            [disabled]="isLensButtonDisabled()">
      <svg-icon icon="plus"></svg-icon>

      <ng2-tooltip direction="right" text="{{ 'bcWorkItemLensList.newLensTooltip' | translate }}"></ng2-tooltip>
    </button>
  </div>

  <ul class="bc-workitem-titles-list">
    <li class="outer-item" [@taskItemAnimation]
        *ngFor="let workItem of lensWorkItemList">

      <div class="item traversable-list-item"
           [attr.data-lens-work-item-id]="workItem.id"
           [attr.tabindex]="0"
           (click)="selectWorkItem(workItem)"
           (keydown)="onWorkItemKeydown(workItem, $event)"
           [ngClass]="generateWorkItemClass(workItem)">
        <div class="item-inner">
          <div class="visitor-avatar">
            <svg-icon icon="lens"></svg-icon>
          </div>

          <div class="visitor-name">{{ workItem.name || 'Lens' }}</div>

          <div class="shortcut">
            <svg-icon icon="enter-key"></svg-icon>
          </div>
        </div>
      </div>
    </li>
  </ul>
</div>
